import { Form } from "antd"
import type { FormInstance } from "antd/es/form/hooks/useForm"
import React from "react"

import { TextInput } from "../../../../../components/Input/TextInput.tsx"
import type { TemplateDocumentFormData } from "../../../types/template-document-form-data.tsx"
import { SignatureFieldsEditor } from "./SignatureFieldsEditor.tsx"

/** Shared by every signature block type — see `build-block-variants.tsx`. */
export interface SignatureBlockProps {
  fieldKey: string
  initialValue?: string
  form: FormInstance<TemplateDocumentFormData>
  index: number
  disabled?: boolean
  /**
   * True only in the template builder. A signer slot and its fields are
   * authored on the template and inherited by every proposal and contract
   * made from it, so the editor belongs to the builder alone — on a document
   * page it would offer a signer list that page cannot declare, and a save
   * there runs no `validateSignatureBlocks` guard.
   */
  isTemplate?: boolean
}

export function SignatureDateBlock({
  fieldKey,
  initialValue,
  form,
  index,
  disabled,
  isTemplate
}: SignatureBlockProps) {
  return (
    <>
      <Form.Item
        name={["block_data", fieldKey, "signer_label"]}
        label="Signature Label"
        initialValue={initialValue}
      >
        <TextInput placeholder="e.g. Client Signature" />
      </Form.Item>
      {isTemplate && (
        <SignatureFieldsEditor form={form} index={index} disabled={disabled} />
      )}
    </>
  )
}
